import { useState, useCallback } from 'react';
import { message } from 'antd';
import { docmanService } from '@/services/docman.service';

export const useDocumentDownload = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const downloadDocument = useCallback(async (
    documentId: string,
    filename?: string
  ) => {
    setLoading(true);
    setError(null);

    try {
      const docId = documentId.startsWith('docman/')
        ? documentId.replace('docman/', '')
        : documentId;

      message.loading({ content: 'Baixando arquivo...', key: 'download' });

      const blob = await docmanService.downloadFile(docId);

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename || 'download';
      document.body.appendChild(a);
      a.click();

      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);

      message.success({ content: 'Download concluído!', key: 'download' });
    } catch (err) {
      const error = err as Error;
      setError(error);
      message.error({ content: 'Erro ao baixar arquivo', key: 'download' });
      throw error;
    } finally {
      setLoading(false);
    }
  }, []);

  return { downloadDocument, loading, error };
};
